const attributePatterns = [
  {
    name: 'sku_serial',
    regex: /^([0-9]{3}[A-Z]{3})([0-9a-zA-Z]{11})$/,
    fields: ['sku', 'serial_number'],
  },
  {
    name: 'serial_sku',
    regex: /^([0-9a-zA-Z]{11})([0-9]{3}[A-Z]{3})$/,
    fields: ['serial_number', 'sku'],
  },
]

export default attributePatterns
